// import { epicsList } from '../../constants/epics.index'

import axiosNew, {  getBackendBaseUrl } from '../../../../helpers/axios'

// GET TEST CASE POOL (for report creation)
export const apiGetTestCasePool = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TEST REPORT
export const apiCreateTestReport = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/add`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TEST RUN LIST
export const apiGetTestRunList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TEST CASE LIST
export const apiGetTestCaseList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/testcase/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TEST CASE
export const createTestCase = (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const createEpicData = await axiosNew({
                url: '/support/testcase/add',
                method: 'post',
                data,
            })
            resolve({ data: createEpicData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE TEST CASE
export const deleteTestCase = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const deleteEpic = await axiosNew({
                url: `/support/testcase/delete/${payload}`,
                method: 'DELETE',
            })
            resolve({ data: deleteEpic?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE MULTIPLE TEST CASES
export const deleteMultipleTestCases = async (ids) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: '/support/testcase/delete-multiple',
                method: 'post',
                data: { ids },
            })
            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TEST CASE DETAIL
export const apiGetTestCaseDetail = (id) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase/detail/${id}`,
                method: 'get',
            })
            resolve({ data: resp?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TEST CASE
export const updateTestCase = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const updatedEpic = await axiosNew({
                url: `/support/testcase/edit/${payload?.id}`,
                method: 'put',
                data: payload?.data,
            })
            resolve({ data: updatedEpic?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TEST REPORT ADD RESULt
export const apiAddResult = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const updatedEpic = await axiosNew({
                url: `/support/testcase-report/edit/${payload?.id}`,
                method: 'put',
                data: payload?.data,
            })
            resolve({ data: updatedEpic?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TEST REPORT NAME
export const apiUpdateTestReportName = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/edit/${payload?.id}`,
                method: 'put',
                data: {
                    name: payload?.name,
                },
            })
            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE TEST REPORT
export const deleteTestReport = async (id) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/delete/${id}`,
                method: 'DELETE',
            })
            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET EPICS LIST
export const apiGetTestRunDetail = (id) => {
    return new Promise(async (resolve) => {
        try {
            const epicData = await axiosNew({
                url: `/support/testcase-report/detail/${id}`,
                method: 'get',
            })
            resolve({ data: epicData?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET EPICS LIST
export const apiGetTestRunTestCaseDetail = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const epicData = await axiosNew({
                url: `/support/testcase-report/testcase/detail`,
                method: 'post',
                data: payload,
            })
            resolve({ data: epicData?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// Get presigned S3 upload URL(s)
export const getAttachmentPreUrl = async (payload) => {
    const data = payload ?? {}
    // debugger
    try {
        const response = await fetch(
            `${getBackendBaseUrl()}/support/upload-file`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Authorization: getAuthorizationHeader(),
                },
                credentials: 'include',
                body: JSON.stringify(data),
            }

        )

        const json = await response.json().catch(() => ({}))
        return { data: json }
    } catch (error) {
        return { data: error?.response?.data ?? {} }
    }
}

export const uploadAttachmentToAWS = async (file, url) => {
    try {
        const formData = new FormData()
        formData.append('file', file) // Assuming the file is passed as 'file'
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type,
            },
            body: file?.originFileObj ? file.originFileObj : file, // Directly sending the file as the body of the request
        })

        if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.statusText}`)
        }
        return response
    } catch (error) {
        console.log('🚀 ~ uploadResumeS3Url ~ error:', error)
    }
}

// ADD TAG
export const apiAddTag = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/tags/add`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TEST CASE LIST
export const apiGetTagList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/tags/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
export const getEpicsListForTC = (params) => {
    return new Promise(async (resolve) => {
        try {
            const epicData = await axiosNew({
                url: `/support/epics/list?${params}`,
                method: 'get',
            })
            resolve({ data: epicData?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const getSprintListForTC = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const sprintData = await axiosNew({
                url: '/support/sprints/list',
                method: 'post',
                data: payload,
            })
            resolve({ data: sprintData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DOWNLOAD TEST CASE EXCEL TEMPLATE
export const downloadTestCaseTemplate = async () => {
    try {
        const resp = await axiosNew({
            url: '/support/testcase/download-template',
            method: 'get',
            responseType: 'blob',
        })

        const contentType = resp?.headers?.['content-type'] || ''
        if (contentType.includes('application/json')) {
            const text = await resp.data.text()
            const json = JSON.parse(text)
            return {
                success: false,
                message: json?.message || 'Failed to download template',
            }
        }

        const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'TestCaseTemplate.xlsx'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        return { success: true }
    } catch (error) {
        return {
            success: false,
            message:
                error?.response?.data?.message ||
                error?.message ||
                'Failed to download template',
        }
    }
}

// IMPORT TEST CASES FROM EXCEL
export const importTestCasesExcel = async ({ file, projectId }) => {
    return new Promise(async (resolve) => {
        try {
            const formData = new FormData()
            formData.append('upload', file)
            formData.append('project', projectId)

            const resp = await axiosNew({
                url: '/support/testcase/upload',
                method: 'post',
                data: formData,
                transformRequest: [(data, headers) => {
                    delete headers['Content-Type']
                    return data
                }],
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            const responseData = error?.response?.data
            resolve({
                data:
                    typeof responseData === 'object' && responseData !== null
                        ? responseData
                        : {
                              success: false,
                              message:
                                  error?.message ||
                                  'Failed to import test cases',
                          },
            })
        }
    })
}

// GET TEST CASE LIST
export const apiDownloadReport = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/support/testcase-report/download/pdf`,
                method: 'post',
                data: payload,
                responseType: 'blob',
            })

            resolve({ data: resp ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
